<template>
  <div class="acomodar">
    <div class="container-fluid py-4 px-4">
     <div class="d-flex ">
        <button class="btn btn-danger ms-2 my-2 " @click="retroceder">
          <i class="bi bi-skip-backward"></i>
        </button>
        <button v-if="permisoVisualizador == 2" class="btn btn-success  ms-2  my-2" @click="editarDatoSolicitud">
          <i class="bi bi-pencil-square "></i>
        </button>
        <button v-if="permisoVisualizador == 18" class="btn btn-success  ms-2  my-2" @click="editarDatoSolicitud">
          <i class="bi bi-pencil-square "></i>
        </button>
        <button v-if="permisoVisualizador == 10" class="btn btn-success  ms-2  my-2"
          @click="editarDatoSolicitudBienestar">
          <i class="bi bi-pencil-square"></i>
        </button>
      </div>

      <div class="border border-1 rounded-3 p-3 mb-2">
        <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
          <i class="bi bi-person-square display-4 text-primary"></i>
          <div>
            <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
              DATOS DE LA SOLICITUD
            </p>
            <p class="mb-0 tituloResaltado fs-4 fw-bold">
              DATOS DE SOLICITANTE
            </p>
          </div>
        </div>
      </div>


      <form action="" @submit.prevent="Grabar">
        <div class="col-12 mb-2">
          <div class="border rounded-3 px-3 py-3 bg-white shadow-sm">

            <p class="fw-bold mb-3">INFORMACIÓN DEL TRABAJADOR</p>

            <div class="row g-3">
              <div class="col-lg-4 col-md-6">
                <label class="tamaño fw-bold mb-1">
                  <i class="bi bi-person text-success fs-6"></i>NOMBRE:</label>
                <input class="form-control tamaños" :disabled="isdisabled" v-model="NomTrabajador">
              </div>

              <div class="col-lg-4 col-md-6">
                <label class="tamaño fw-bold mb-1">
                  <i class="bi bi-person text-success fs-6"></i>CARGO:</label>
                <input class="form-control tamaños" :disabled="isdisabled" v-model="CargoBoleta">
              </div>

              <div class="col-lg-3 col-md-6 col-12 ">
              <label class="tamaño d-flex align-items-center fw-bold mb-1">
                <i class="bi bi-briefcase-fill text-success fs-6"></i> PUESTO SOLICITADO:
              </label>
              <select  @change="Puesto($event)"
               :disabled='isdisabled'  class="form-select  tamaños" required>
                <option disabled selected >  {{nomPuesto ='' ? '-- SELECCIONAR PUESTO --' : nomPuesto}}</option>
                <option v-for="puesto in puestos" :key="puesto.id" :value="puesto.idPuesto">
                  {{ puesto.ptoNombre }}
                </option>
              </select>
            </div>
            </div>
          </div>
        </div>


        <div class="col-12 mb-2">
          <div class="border rounded-3 px-3 py-4 bg-white shadow-sm">
            <p class="fw-bold mb-3">DATOS GENERALES</p>
            <div class="row g-3">

              <!-- Empresa -->
              <div class="col-lg-3 col-md-6">
                <label class="tamaño fw-bold mb-1">
                  <i class="bi bi-building-check text-success fs-6"></i> EMPRESA
                </label>
                <select class="form-select tamaños" :disabled="isdisabled" @change="Empresa($event)">
                  <option selected disabled>{{ NomEmpresa }}</option>
                  <option v-for="empresas in DniEmpre" :key="empresas.id" :value="empresas.id">
                    {{ empresas.empRazSocial }}
                  </option>
                </select>
              </div>

              <!-- Centro Costos -->
              <div class="col-lg-3 col-md-6">
                <label class="tamaño fw-bold mb-1">
                  <i class="bi bi-grid-1x2 text-primary fs-6"></i> CENTRO DE COSTOS (CC)
                </label>
                <select class="form-select tamaños" :disabled="isdisabled" @change="CostosEvent($event)">
                  <option selected disabled>{{ CentroCosto }}</option>
                  <option v-for="(CC, index) in CentroCoste" :key="index" :value="CC.cenCodigo">
                    {{ CC.cenNombre }}
                  </option>
                </select>
              </div>

              <!-- Fecha deadline -->
              <div class="col-lg-3 col-md-6">
                <label class="tamaño text-danger fw-bold mb-1">
                  <i class="bi bi-calendar-event fs-6 "></i> FECHA DEADLINE
                </label>
                <input type="date" class="form-control tamaños" :disabled="isdisabled" v-model="form.fecPresentacion" />
              </div>

              <!-- Fecha estimada -->
              <div class="col-lg-3 col-md-6">
                <label class="tamaño fw-bold mb-1 ">
                  <i class="bi bi-calendar-check fs-6"></i> FECHA FINAL ESTIMADA
                </label>
                <input type="date" class="form-control tamaños" :disabled="isdisabled" v-model="form.FecSolicitada" />
              </div>

            </div>
          </div>
        </div>

        <div class="col-12 mb-2">
          <div class="border rounded-3 px-3 py-3 bg-white shadow-sm">

            <p class="fw-bold mb-2">DATOS DEL PUESTO VACANTE</p>

            <div class="row g-3">

              <!-- Empresa -->
              <div class="col-lg-3 col-md-6">
                <label class="tamaño fw-bold mb-1">
                  <i class="bi bi-building-check text-primary fs-6"></i> EMPRESA
                </label>
                <select class="form-select tamaños" :disabled="isdisabled" @change="Empresa($event)">
                  <option selected disabled>{{ NomEmpresa }}</option>
                  <option v-for="empresas in DniEmpre" :key="empresas.id" :value="empresas.id">
                    {{ empresas.empRazSocial }}
                  </option>
                </select>
              </div>

              <!-- CC -->
              <div class="col-lg-3 col-md-6">
                <label class="tamaño fw-bold mb-1">
                  <i class="bi bi-grid-1x2 text-primary fs-6"></i> CC
                </label>
                <select class="form-select tamaños" :disabled="isdisabled" @change="CostosEvent($event)">
                  <option selected disabled>{{ CentroCosto }}</option>
                  <option v-for="(cc, index) in CentroCoste" :key="index" :value="cc.cenCodigo">
                    {{ cc.cenNombre }}
                  </option>
                </select>
              </div>

              <!-- SCC -->
              <div class="col-lg-3 col-md-6">
                <label class="tamaño fw-bold mb-1">
                  <i class="bi bi-grid-1x2 text-primary fs-6"></i> SUB CC
                </label>
                <select class="form-select tamaños" :disabled="isdisabled" @change="SubCostros($event)">
                  <option selected disabled>{{ SubCentroCosto }}</option>
                  <option v-for="scc in SubCentroCoste" :key="scc.id" :value="scc.cenSubCentro">
                    {{ scc.cenNombre }}
                  </option>
                </select>
              </div>

              <!-- SSCC -->
              <div class="col-lg-3 col-md-6">
                <label class="tamaño fw-bold mb-1">
                  <i class="bi bi-grid-1x2 text-primary fs-6"></i> SUB SUB CC
                </label>
                <select class="form-select tamaños" :disabled="isdisabled" @change="SubSubCentroCostoId($event)">
                  <option selected disabled>{{ SubSubCentroCosto }}</option>
                  <option v-for="sscc in SubSubCentroCoste" :key="sscc.id" :value="sscc.id">
                    {{ sscc.cenNombre }}
                  </option>
                </select>
              </div>

              <!-- Cant postulantes -->
              <div class="col-lg-2 col-md-6">
                <label class="tamaño fw-bold mb-1">
                  <i class="bi bi-people-fill text-primary fs-6"></i> CANT. POSTULANTES
                </label>
                <input class="form-control tamaños" :disabled="isdisabled" v-model="form.CanPostulante" />
              </div>

              <!-- Motivo -->
              <div class="col-lg-2 col-md-6">
                <label class="tamaño fw-bold mb-1">
                  <i class="bi bi-question-circle text-primary fs-6"></i> MOTIVO
                </label>
                <select class="form-select tamaños" :disabled="isdisabled" @change="Motivo($event)">
                  <option selected disabled>{{ DesMotivo }}</option>
                  <option v-for="motivo in motivoSolicitud" :key="motivo.id" :value="motivo.parCorrelativo">
                    {{ motivo.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- Detalle -->
              <div class="col-lg-2 col-md-6">
                <label class="tamaño fw-bold mb-1">DETALLE MOTIVO</label>
                <input class="form-control tamaños" :disabled="isdisabled" v-model="DetMotivo" />
              </div>

              <!-- Gerencia -->
              <div class="col-lg-2 col-md-6">
                <label class="tamaño fw-bold mb-1">GERENCIA</label>
                <select class="form-select tamaños" :disabled="isdisabled" @change="Gerencia($event)">
                  <option selected disabled>{{ DesGerencia }}</option>
                  <option v-for="g in gerencia" :key="g.id" :value="g.parCorrelativo">
                    {{ g.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- Departamento -->
              <div class="col-lg-1 col-md-6">
                <label class="tamaño fw-bold mb-1">DEPARTAMENTO</label>
                <select class="form-select tamaños" :disabled="isdisabled" @change="Depa($event)">
                  <option selected disabled>{{ DesDepartamento }}</option>
                  <option v-for="d in DepartamentoDistrito" :key="d.id" :value="d.idParametro">
                    {{ d.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- Provincia -->
              <div class="col-lg-1 col-md-6">
                <label class="tamaño fw-bold mb-1">PROVINCIA</label>
                <select class="form-select tamaños" :disabled="isdisabled" @change="Province($event)">
                  <option selected disabled>{{ DesProvincia }}</option>
                  <option v-for="p in provincias" :key="p.id" :value="p.idParametro">
                    {{ p.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- Distrito -->
              <div v-if="regiones != 1733" class="col-lg-2 col-md-6">
                <label class="tamaño fw-bold mb-1">DISTRITO</label>
                <select class="form-select tamaños" :disabled="isdisabled" @change="DistritoDes($event)">
                  <option selected>{{ DesDistrito }}</option>
                  <option v-for="d in distrito" :key="d.id" :value="d.parCorrelativo">
                    {{ d.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- Zona -->
              <div v-else class="col-lg-3 col-md-6">
                <label class="tamaño fw-bold mb-1">ZONA</label>
                <select class="form-select tamaños" @change="DistritoDes($event)">
                  <option disabled selected>-- SELECCIONAR --</option>
                  <option v-for="z in subRegiones" :key="z.id" :value="z.parCorrelativo">
                    {{ z.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- Descripción -->
              <div class="col-lg-12">
                <label class="tamaño fw-bold mb-1">DESCRIPCIÓN EXTRA</label>
                <textarea required :disabled="isdisabled" class="form-control tamaños"
                  placeholder="Leave a comment here" id="floatingTextarea2" style="height: 100px"
                  v-model="form.DesExtra"></textarea>
              </div>

              <!-- Adjuntos -->
              <div class="col-lg-8">
                <h6 class="fw-bold mt-3 tamaño">ADJUNTO</h6>
                <p v-if="form.adjunto != 1">{{ adjuntoNombre }}</p>
                <input type="file" class="form-control mt-2 tamaños" @change="onFileSelected" />
              </div>

            </div>
          </div>
        </div>

        <div class="col-12 mt-2 mb-2">
          <div class="border rounded-3 px-3 py-3 bg-white shadow-sm">

            <p class="fw-bold mb-3 pintar">CONDICIONES LABORALES</p>

            <div class="row g-2">

              <!-- TIPO DE CONTRATO -->
              <div class="col-lg-3 col-md-6">
                <p class="tamaño fw-bold mb-1">TIPO DE CONTRATO:</p>
                <select @change="TipoContrato($event)" :disabled="isdisabled" class="form-select tamaños">
                  <option selected disabled>{{ DesTipContrato }}</option>
                  <option v-for="contrato in contratos" :key="contrato.id" :value="contrato.parCorrelativo">
                    {{ contrato.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- PLAZO -->
              <div class="col-lg-1 col-md-6">
                <p class="tamaño fw-bold mb-1">PLAZO:</p>
                <input type="text" :disabled="isdisabled" class="form-control tamaños" v-model="form.Plazo" />
              </div>

              <!-- TIEMPO -->
              <div class="col-lg-2 col-md-6">
                <p class="tamaño fw-bold mb-1">TIEMPO:</p>
                <select @change="Tiempo($event)" :disabled="isdisabled" class="form-select tamaños">
                  <option selected disabled>{{ DesTiempo }}</option>
                  <option v-for="tiempo in tiempos" :key="tiempo.id" :value="tiempo.parCorrelativo">
                    {{ tiempo.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- FECHA INICIO -->
              <div class="col-lg-2 col-md-6">
                <p class="tamaño fw-bold mb-1">FEC. INICIO CONTRATO:</p>
                <input type="date" :disabled="isdisabled" class="form-control tamaños" v-model="form.FecIniContrato" />
              </div>

              <!-- FECHA FIN -->
              <div class="col-lg-2 col-md-6">
                <p class="tamaño fw-bold mb-1">FEC. FIN CONTRATO:</p>
                <input type="date" :disabled="isdisabled" class="form-control tamaños" v-model="form.FecFinContrato" />
              </div>

              <!-- CATEGORÍA OCUPACIONAL -->
              <div class="col-lg-2 col-md-6">
                <p class="tamaño fw-bold mb-1">CATEGORÍA OCUPACIONAL:</p>
                <select @change="CategoriaOcupacional($event)" :disabled="isdisabled" class="form-select tamaños">
                  <option selected disabled>{{ DesCatOcupacional }}</option>
                  <option v-for="ocupo in ocupacional" :key="ocupo.id" :value="ocupo.parCorrelativo">
                    {{ ocupo.parDescripcion }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>


        <div class="col-12 mt-2 mb-2">
          <div class="border rounded-3 px-3 py-3 bg-white shadow-sm">

            <p class="fw-bold mb-3 pintar">CONDICIONES DE TRABAJO</p>

            <div class="row g-3">

              <!-- LUGAR DE TRABAJO -->
              <div class="col-lg-3 col-md-6">
                <p class="tamaño fw-bold mb-1">LUGAR DE TRABAJO:</p>
                <input type="text" required :disabled="isdisabled" class="form-control tamaños"
                  v-model="form.LugarTrabajo" />
              </div>

              <!-- HORARIO DE TRABAJO -->
              <div class="col-lg-2 col-md-6">
                <p class="tamaño fw-bold mb-1">HORARIO DE TRABAJO:</p>
                <input type="text" required :disabled="isdisabled" class="form-control tamaños"
                  v-model="form.HorTrabajo" />
              </div>

              <!-- SUELDO MENSUAL -->
              <div class="col-lg-3 col-md-6">
                <p class="tamaño fw-bold mb-1">SUELDO MENSUAL:</p>
                <input type="text" :disabled="isdisabled" class="form-control tamaños" v-model="form.SueldoMensual" />
              </div>

              <!-- SUELDO DIARIO -->
              <div class="col-lg-2 col-md-6">
                <p class="tamaño fw-bold mb-1">SUELDO DIARIO:</p>
                <input type="text" :disabled="isdisabled" class="form-control tamaños" v-model="form.SueldoDiario" />
              </div>

              <!-- MODALIDAD DE TRABAJO -->
              <div class="col-lg-2 col-md-6">
                <p class="tamaño fw-bold mb-1">MODALIDAD DE TRABAJO:</p>
                <select @change="ModalidadTrabajo($event)" :disabled="isdisabled" class="form-select tamaños">
                  <option selected>{{ DesModTrabajo }}</option>
                  <option v-for="modalidad in modalidadTrabajo" :key="modalidad.id" :value="modalidad.parCorrelativo">
                    {{ modalidad.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- MONEDA -->
              <div class="col-lg-2 col-md-6">
                <p class="tamaño fw-bold mb-1">MONEDA:</p>
                <select @change="Monedas($event)" :disabled="isdisabled" class="form-select tamaños">
                  <option selected>{{ DesMoneda }}</option>
                  <option v-for="moneda in monedita" :key="moneda.id" :value="moneda.parCorrelativo">
                    {{ moneda.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- OPORTUNIDAD DE PAGO -->
              <div class="col-lg-2 col-md-6">
                <p class="tamaño fw-bold mb-1">OPORTUNIDAD DE PAGO:</p>
                <select @change="Oportunidad($event)" :disabled="isdisabled" class="form-select tamaños">
                  <option selected disabled>{{ DesOpoPago }}</option>
                  <option v-for="opo in oportunidad" :key="opo.id" :value="opo.parCorrelativo">
                    {{ opo.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- DIAS DESCANSO -->
              <div class="col-lg-1 col-md-6">
                <p class="tamaño fw-bold mb-1">DESCANSO (DÍAS):</p>
                <input type="text" :disabled="isdisabled" class="form-control tamaños" v-model="form.DiasDescanso" />
              </div>

              <!-- VARIABLE -->
              <div class="col-lg-1 col-md-6">
                <p class="tamaño fw-bold mb-1">VARIABLE:</p>
                <input type="text" :disabled="isdisabled" class="form-control tamaños" v-model="form.MonVariable" />
              </div>

              <!-- ALIMENTACIÓN -->
              <div class="col-lg-1 col-md-6">
                <p class="tamaño fw-bold mb-1">ALIMENTACIÓN:</p>
                <input type="text" :disabled="isdisabled" class="form-control tamaños" v-model="form.MonAlimentacion" />
              </div>

              <!-- MOVILIDAD -->
              <div class="col-lg-1 col-md-6">
                <p class="tamaño fw-bold mb-1">MOVILIDAD:</p>
                <input type="text" :disabled="isdisabled" class="form-control tamaños" v-model="form.MonMovilidad" />
              </div>

              <!-- HORAS EXTRA -->
              <div class="col-lg-1 col-md-6">
                <p class="tamaño fw-bold mb-1">HRS. EXTRA:</p>
                <input type="text" :disabled="isdisabled" class="form-control tamaños" v-model="form.HoraExtra" />
              </div>

              <!-- VIÁTICOS -->
              <div class="col-lg-1 col-md-6">
                <p class="tamaño fw-bold mb-1">VIÁTICOS:</p>
                <input type="text" :disabled="isdisabled" class="form-control tamaños" v-model="form.MonViatico" />
              </div>

              <!-- OTROS -->
              <div class="col-lg-2 col-md-6">
                <p class="tamaño fw-bold mb-1">OTROS:</p>
                <input type="text" :disabled="isdisabled" class="form-control tamaños" v-model="form.MonOtro" />
              </div>

              <!-- CAMPAÑA -->
              <div class="col-lg-6 col-md-6 mt-3">
                <label class="tamaños">
                  <input type="checkbox" :disabled="isdisabled" v-model="form.Campana" />
                  &nbsp; Campaña (La etapa de entrevista y capacitación será presencial)
                </label>
              </div>

            </div>
          </div>
        </div>



        <div class="col-12 mt-2 mb-2">
          <div class="border rounded-3 px-3 py-3 bg-white shadow-sm">

            <p class="fw-bold mb-3 pintar">
              DOCUMENTOS GESTIONADOS POR EL ÁREA DE SELECCIÓN
            </p>

            <div class="row g-3">

              <!-- CHECKBOXES EN LÍNEA -->
              <div class="col-12">
                <div class="d-flex flex-wrap gap-4 tamaños">

                  <label class="d-flex align-items-center gap-2">
                    <input type="checkbox" class="form-check-input" v-model="form.solDisViaje" />
                    DISPONIBILIDAD DE VIAJE
                  </label>

                  <label class="d-flex align-items-center gap-2">
                    <input type="checkbox" class="form-check-input" v-model="form.solMovPropio" />
                    USO DE MÓVIL PROPIO CON PAGO DE DATOS
                  </label>

                  <label class="d-flex align-items-center gap-2">
                    <input type="checkbox" class="form-check-input" v-model="form.solAplicativo" />
                    USO DE APLICATIVOS
                  </label>

                </div>
              </div>

              <!-- CARNET DE SANIDAD -->
              <div class="col-lg-6 col-md-6">
                <label class="d-flex align-items-center gap-2 tamaños">
                  <input type="checkbox" :disabled="isdisabled" v-model="form.indSanidad" class="form-check-input" />
                  CARNET DE SANIDAD
                </label>
              </div>

              <!-- VULNERABILIDAD -->
              <div class="col-lg-6 col-md-6">
                <label class="d-flex align-items-center gap-2 tamaños">
                  <input type="checkbox" :disabled="isdisabled" v-model="form.indVulnerabilidad"
                    class="form-check-input" />
                  DECLARACIÓN JURADA DE VULNERABILIDAD
                </label>
              </div>

              <!-- CERTIJOVEN -->
              <div class="col-lg-6 col-md-6">
                <label class="d-flex align-items-center gap-2 tamaño">
                  <input type="checkbox" :disabled="isdisabled" v-model="form.indCertijoven" class="form-check-input" />
                  CERTIFICADO DE ANTECEDENTES / CERTIJOVEN
                </label>
              </div>

            </div>
          </div>
        </div>


        <div class="col-12 mt-2 mb-2">
          <div class="border rounded-3 px-3 py-3 bg-white shadow-sm">

            <p class="fw-bold mb-3 pintar">
              DOCUMENTOS GESTIONADOS POR EL ÁREA DE BIENESTAR
            </p>

            <div class="row g-3">

              <!-- EMPO -->
              <div class="col-lg-4 col-md-6">
                <label class="d-flex align-items-center gap-2 tamaño">
                  <input type="checkbox" :disabled="isdisabledBienestar" v-model="form.indEmpo"
                    class="form-check-input" />
                  EXAMEN MÉDICO PRE-OCUPACIONAL (EMPO)
                </label>
              </div>

              <!-- COVID (por si lo activas después) -->
              <!--
      <div class="col-lg-4 col-md-6">
        <label class="d-flex align-items-center gap-2 tamaño">
          <input
            type="checkbox"
            :disabled="isdisabledBienestar"
            v-model="form.indCovid"
            class="form-check-input"
          />
          PRUEBA COVID
        </label>
      </div>
      -->

            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center mt-2 border rounded-3 px-3 py-3 bg-white shadow-sm">
          <button class="btn btn-success mx-2 mb-3 px-4 py-2" type="submit">
            <i class="bi bi-floppy"></i>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

import { mapGetters } from "vuex";
export default {
  name: "SolimanologDatosDeSolicitud",

  data() {
    return {
      isdisabled: true,
      isdisabledBienestar: true,

      form: {
        IdSolicitud: "",
        idPuesto: "",
        fecPresentacion: "",
        FecSolicitada: "",
        FecIniContrato: "",
        FecFinContrato: "",
        IdTrabajador: "",
        idEmpresa: "",
        codCentro: "",
        codScc: "",
        codSscc: "",
        codMotivo: "",
        codGerencia: "",
        DesExtra: "",
        Plazo: "",
        solUbigeo: "",
        // codTipContratacion: "",
        codTiempo: "",
        codCatOcupacional: "",
        LugarTrabajo: "",
        HorTrabajo: "",
        DiasDescanso: "",
        SueldoMensual: "",
        MonVariable: "",
        MonAlimentacion: "",
        MonMovilidad: "",
        SueldoDiario: "",
        HoraExtra: "",
        MonViatico: "",
        MonOtro: "",
        CanPostulante: "",
        codTipContrato: "",
        codModTrabajo: "",
        codMoneda: "",
        codOpoPago: "",
        idSelAsignado: "",
        indVacuna: Boolean,
        indSanidad: Boolean,
        indVulnerabilidad: Boolean,
        indCertijoven: Boolean,
        indEmpo: Boolean,
        indCovid: false,
        adjunto: "",
        Campana: "",
        indJudiciales: Boolean,
        indPoliciales: Boolean,
        indPenales: Boolean,
        solDisViaje: false,
        solMovPropio: false,
        solAplicativo: false
      },

      NomTrabajador: "",
      CargoBoleta: "",
      NomEmpresa: "",
      CentroCosto: "",
      SubCentroCosto: "",
      SubSubCentroCosto: "",
      DesMotivo: "",
      DetMotivo: "",
      DesGerencia: "",
      DesDepartamento: "",
      DesProvincia: "",
      DesDistrito: "",
      nomPuesto: "",
      DesTipContratacion: "",
      DesTiempo: "",
      DesCatOcupacional: "",
      DesTipContrato: "",

      DesModTrabajo: "",
      DesMoneda: "",
      DesOpoPago: "",

      IndVacuna: "",
      IndSanidad: "",
      IndVulnerabilidad: "",
      IndCertiJoven: "",
      IndCovid: "",
      IndEmpo: "",

      dniTrabajador: "",
      cenCodigoCentro: "",
      puesto: [],

      CentroCoste: [],
      SubCentroCoste: [],
      SubSubCentroCoste: [],
      motivoSolicitud: [],
      gerencia: [],
      provincias: [],
      distrito: [],
      ocupacional: [],
      contratacion: [],
      tiempos: [],
      contratos: [],
      modalidadTrabajo: [],
      monedita: [],
      oportunidad: [],
      apagate: true,
      nombreRecuperado: "",
      adjuntoNombre: "",
      fechaDeAhora: null,
      permisoVisualizador: "",
      subRegiones: [],
      regiones: "",
      puestos:[]
    };
  },

  async mounted() {
    this.permisoVisualizador = localStorage.getItem("idPerfil");
    const tiempoTranscurrido = Date.now();
    const hoy = new Date(tiempoTranscurrido);
    this.fechaDeAhora = hoy.toISOString().slice(0, 10);
    // this.form.IdTrabajador  = localStorage.getItem("idTrabajdor");
    this.dniTrabajador = localStorage.getItem("dniUsers");
    console.log(this.dniTrabajador);
    const api = await this.axios.get(
      "SolicitudData/Obtener/" + this.$route.params.edit
    );
    this.form.IdTrabajador = api.data[0].idTrabajador
    this.form.IdSolicitud = api.data[0].idSolicitud;
    this.form.idPuesto = api.data[0].idPuesto;
    console.log('puetos',api.data)
    this.form.idEmpresa = api.data[0].idEmpresa;
    this.form.codCentro = api.data[0].codCentro;
    this.form.codScc = api.data[0].codScc;
    this.form.codSscc = api.data[0].codSscc;
    this.form.codMotivo = api.data[0].codMotivo;
    this.form.codGerencia = api.data[0].codGerencia;
    this.form.solUbigeo = api.data[0].codDistrito;
    // this.form.codTipContratacion = api.data[0].codTipContratacion;
    this.form.codTiempo = api.data[0].codTiempo;
    this.form.codCatOcupacional = api.data[0].codCatOcupacional;
    this.form.codTipContrato = api.data[0].codTipContrato;
    this.form.codModTrabajo = api.data[0].codModTrabajo;
    this.form.codMoneda = api.data[0].codMoneda;
    this.form.codOpoPago = api.data[0].codOpoPago;
    this.form.indVacuna = api.data[0].indVacuna;
    this.form.indJudiciales = api.data[0].indJudiciales;
    this.form.indPoliciales = api.data[0].indPoliciales;
    this.form.indPenales = api.data[0].indPenales;

    this.form.indSanidad = api.data[0].indSanidad;
    this.form.indVulnerabilidad = api.data[0].indVulnerabilidad;
    this.form.indCertijoven = api.data[0].indCertiJoven;
    this.form.indEmpo = api.data[0].indEmpo;
    this.form.indCovid = api.data[0].indCovid;
    this.form.fecPresentacion = api.data[0].fecPresentacions.slice(0, 10);
    this.form.FecSolicitada = api.data[0].fecSolicitada.slice(0, 10);
    this.NomTrabajador = api.data[0].nomTrabajador;
    this.CargoBoleta = api.data[0].cargoBoleta;
    this.NomEmpresa = api.data[0].nomEmpresa;
    this.CentroCosto = api.data[0].centroCosto;
    this.SubCentroCosto = api.data[0].subCentroCosto;
    this.SubSubCentroCosto = api.data[0].subSubCentroCosto;
    this.form.CanPostulante = api.data[0].canPostulante;
    this.DesMotivo = api.data[0].desMotivo;
    this.DetMotivo = api.data[0].detMotivo;
    this.DesGerencia = api.data[0].desGerencia;
    this.DesDepartamento = api.data[0].desDepartamento;
    this.DesProvincia = api.data[0].desProvincia;
    this.form.DesExtra = api.data[0].desExtra;
    // this.DesTipContratacion = api.data[0].desTipContratacion;
    this.form.Plazo = api.data[0].plazo;
    this.form.idSelAsignado = api.data[0].idSelAsignado;
    this.DesTiempo = api.data[0].desTiempo;
    this.form.FecIniContrato = api.data[0].fecIniContrato.slice(0, 10);
    this.form.FecFinContrato = api.data[0].fecFinContrato.slice(0, 10);
    this.form.adjunto = api.data[0].adjunto;
    this.DesCatOcupacional = api.data[0].desCatOcupacional;
    this.DesTipContrato = api.data[0].desTipContrato;
    this.form.LugarTrabajo = api.data[0].lugarTrabajo;
    this.form.HorTrabajo = api.data[0].horTrabajo;
    this.form.SueldoMensual = api.data[0].sueldoMensual;
    this.form.SueldoDiario = api.data[0].sueldoDiario;
    this.DesModTrabajo = api.data[0].desModTrabajo;
    this.form.Campana = api.data[0].campana;
    this.DesMoneda = api.data[0].desMoneda;
    this.DesOpoPago = api.data[0].desOpoPago;
    this.form.DiasDescanso = api.data[0].diasDescanso;
    this.form.MonVariable = api.data[0].monVariable;
    this.form.MonAlimentacion = api.data[0].monAlimentacion;
    this.form.MonMovilidad = api.data[0].monMovilidad;
    this.form.HoraExtra = api.data[0].horaExtra;
    this.form.MonViatico = api.data[0].monViatico;
    this.form.MonOtro = api.data[0].monOtro;
    this.nomPuesto = api.data[0].nomPuesto;
    this.DesDistrito = api.data[0].desDistrito;

    this.nombreRecuperado = api.data[0].adjunto;

    let r = await this.axios.get("PuestoData/ListadoPuesto");
    this.puestos = r.data;

    let solicitud = await this.axios.get("ParametroData/Parametro/29");
    this.motivoSolicitud = solicitud.data;

    let subRegiones = await this.axios.get("ParametroData/Parametro/7892");
    this.subRegiones = subRegiones.data;

    let gerencia = await this.axios.get("ParametroData/Parametro/22");
    this.gerencia = gerencia.data;

    let contrat = await this.axios.get("ParametroData/Parametro/49");
    this.contratacion = contrat.data;

    let tiempo = await this.axios.get("ParametroData/Parametro/7612");
    this.tiempos = tiempo.data;

    let categoria = await this.axios.get("ParametroData/Parametro/7495");
    this.ocupacional = categoria.data;

    let contrato = await this.axios.get("ParametroData/Parametro/7406");
    this.contratos = contrato.data;

    let modalidad = await this.axios.get("ParametroData/Parametro/52");
    this.modalidadTrabajo = modalidad.data;

    let moneda = await this.axios.get("ParametroData/Parametro/7317");
    this.monedita = moneda.data;

    let pago = await this.axios.get("ParametroData/Parametro/7616");
    this.oportunidad = pago.data;
  },

  computed: {
    ...mapGetters("users", ["DniEmpre"]),
    ...mapGetters("parametros", ["DepartamentoDistrito"]),
  },
  created() {
    this.cambiarEstadoNavbar();
  },
  methods: {
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
    onFileSelected(event) {
      this.form.adjunto = event.target.files[0];
      if (event.target.value != "") {
        this.adjuntoNombre = event.target.files[0].name;
        this.apagate = false;
      } else {
        this.apagate = false;
        this.adjuntoNombre = this.nombreRecuperado;
        this.form.adjunto = this.nombreRecuperado;
      }
    },
    Grabar() {
      this.form.IdSolicitud = this.$route.params.edit;
      console.log(this.form);
      const fd = new FormData();

      fd.append("IdPuesto", this.form.idPuesto);
      fd.append("IdSolicitud", this.form.IdSolicitud);
      fd.append("FecSolicitadas", this.form.FecSolicitada);
      fd.append("FecPresentacions", this.form.fecPresentacion);
      fd.append("DesMotivo", this.DesMotivo);
      fd.append("IdTrabajador", this.form.IdTrabajador);
      fd.append("CodMotivo", this.form.codMotivo);
      fd.append("CanPostulante", this.form.CanPostulante);
      fd.append("DesExtra", this.form.DesExtra);
      fd.append("IdEmpresa", this.form.idEmpresa);
      fd.append("CodCentro", this.form.codCentro);
      fd.append("CodScc", this.form.codScc);
      fd.append("CodSscc", this.form.codSscc);
      fd.append("CodGerencia", this.form.codGerencia);
      fd.append("SolUbigeo", this.form.solUbigeo);
      fd.append("Campana", this.form.Campana);
      // fd.append("CodTipContratacion", this.form.codTipContratacion);
      fd.append("Plazo", this.form.Plazo);
      fd.append("CodTiempo", this.form.codTiempo);
      fd.append("CodCatOcupacional", this.form.codCatOcupacional);
      fd.append("CodTipContrato", this.form.codTipContrato);
      fd.append("FecIniContratos", this.form.FecIniContrato);
      fd.append("FecFinContratos", this.form.FecFinContrato);
      fd.append("LugarTrabajo", this.form.LugarTrabajo);
      fd.append("HorTrabajo", this.form.HorTrabajo);
      fd.append("CodModTrabajo", this.form.codModTrabajo);
      fd.append("DiasDescanso", this.form.DiasDescanso);
      fd.append("CodMoneda", this.form.codMoneda);
      fd.append("SueldoMensual", this.form.SueldoMensual);
      fd.append("SueldoDiario", this.form.SueldoDiario);
      fd.append("DiasDescanso", this.form.DiasDescanso);
      fd.append("MonVariable", this.form.MonVariable);
      fd.append("MonAlimentacion", this.form.MonAlimentacion);
      fd.append("MonMovilidad", this.form.MonMovilidad);
      fd.append("HoraExtra", this.form.HoraExtra);
      fd.append("MonViatico", this.form.MonViatico);
      fd.append("MonOtro", this.form.MonOtro);
      fd.append("CodOpoPago", this.form.codOpoPago);
      fd.append("IndEmpo", this.form.indEmpo);
      fd.append("IndVacuna", this.form.indVacuna);
      fd.append("IndCovid", this.form.indCovid);
      fd.append("IndSanidad", this.form.indSanidad);
      fd.append("IndVulnerabilidad", this.form.indVulnerabilidad);
      fd.append("IndPenales", this.form.indPenales);
      fd.append("IndPoliciales", this.form.indPoliciales);
      fd.append("IndJudiciales", this.form.indJudiciales);
      fd.append("IndCertiJoven", this.form.indCertijoven);
      fd.append("idSelAsignado", this.form.idSelAsignado);
      fd.append("Adjunto", this.form.adjunto);
      fd.append("ArchivoSol", this.form.adjunto);
      fd.append("solDisViaje", this.form.solDisViaje);
      fd.append("solMovPropio", this.form.solMovPropio);
      fd.append("solAplicativo", this.form.solAplicativo);
      this.axios.put("SolicitudData/Modificar", fd).then((r) => {
        console.log(r.data);
        console.log(this.form.adjunto);
        if (r.data == true) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se realizo tus cambios",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },

    getAttribute() {
      this.axios.get("PuestoData/ListadoPuesto").then((r) => {
        this.puesto = r.data;

        // for(let index of this.puesto){
        //   if(index.ptoNombre == this.nomPuesto){
        //     this.form.idPuesto = index.idPuesto
        //   }
        // }
      });
    },

    editarDatoSolicitud() {
      this.isdisabled = !this.isdisabled;

      this.getAttribute();
    },

    editarDatoSolicitudBienestar() {
      this.isdisabledBienestar = !this.isdisabledBienestar;

      this.getAttribute();
    },

    Puesto(event) {
      this.form.idPuesto = event.target.value;
    },

    Empresa(event) {
      this.form.idEmpresa = event.target.value;

      // this.axios.get(`Ccosto/ObtenerCcosto/${event.target.value}`).then((r) => {
      //   this.CentroCoste = r.data;
      // });

      this.axios
        .get(
          `Ccosto/CentroxTrabajador?idEmpresa=${event.target.value}&dniUser=${this.dniTrabajador}`
        )
        .then((r) => {
          this.CentroCoste = r.data;
        });
    },

    CostosEvent(event) {
      console.log(event.target.value);
      this.cenCodigoCentro = event.target.value;
      // this.axios
      //   .get(`SubCentro/ObtenerCentro/${event.target.value}`)
      //   .then((r) => {
      //     this.SubCentroCoste = r.data;
      //   });
      this.axios
        .get(
          `SubCentro/SubCxTrabajador?codCenCosto=${this.cenCodigoCentro}&dniUser=${this.dniTrabajador}&idEmpresa=${this.form.idEmpresa}`
        )
        .then((r) => {
          this.SubCentroCoste = r.data;
        });
    },

    SubCostros(event) {
      console.log(event.target.value);
      // this.axios
      //   .get(`SubSubCentro/ObtenerSubCentro/${event.target.value}`)
      //   .then((r) => {
      //     this.SubSubCentroCoste = r.data;
      //   });

      this.axios
        .get(
          `SubSubCentro/SScxTrabajador?idEmpresa=${this.form.idEmpresa}&dniUser=${this.dniTrabajador}&codCentro=${this.cenCodigoCentro}&codSubCentro=${event.target.value}`
        )
        .then((r) => {
          this.SubSubCentroCoste = r.data;
          console.log(r.data);
        });
    },

    SubSubCentroCostoId(event) {
      this.axios
        .get(`SubSubCentro/ObtenerSububCentro/${event.target.value}`)
        .then((r) => {
          this.form.codCentro = r.data[0].cenCodigo;
          this.form.codScc = r.data[0].cenSubCodigo;
          this.form.codSscc = r.data[0].cenSubSubCodigo;

          console.log(this.form.codCentro, this.form.codScc, this.form.codSscc);
        });
    },

    Motivo(event) {
      this.form.codMotivo = event.target.value;
    },

    Gerencia(event) {
      this.form.codGerencia = event.target.value;
    },

    Depa(event) {
      this.axios
        .get(`ParametroData/ParametroDepxProv/${event.target.value}`)
        .then((r) => {
          this.form.codDepartamento = r.data[0].parCorrelativo;
          console.log(this.form.codDepartamento);
        });
      this.axios
        .get(`ParametroData/Parametro/${event.target.value}`)
        .then((r) => {
          this.provincias = r.data;
        });
    },

    Province(event) {
      console.log(event.target.value);
      this.regiones = event.target.value

      this.axios.get(`DistritoData/Listar/${event.target.value}`).then((r) => {
        this.distrito = r.data;
      });
    },

    DistritoDes(event) {
      this.form.solUbigeo = event.target.value;
      console.log(event.target.value);
    },

    // TipoContratacion(event) {
    //   this.form.codTipContratacion = event.target.value;
    // },

    Tiempo(event) {
      this.form.codTiempo = event.target.value;
    },

    CategoriaOcupacional(event) {
      this.form.codCatOcupacional = event.target.value;
      console.log(this.form.codCatOcupacional);
    },

    TipoContrato(event) {
      this.form.codTipContrato = event.target.value;
      console.log(this.form.codTipContrato);
    },

    ModalidadTrabajo(event) {
      this.form.codModTrabajo = event.target.value;
    },

    Monedas(event) {
      this.form.codMoneda = event.target.value;
      console.log(this.form.codMoneda);
    },

    Oportunidad(event) {
      this.form.codOpoPago = event.target.value;
      console.log(this.form.codOpoPago);
    },

    retroceder() {
      window.history.back();
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  /* margin-right: 0.5rem !important; */
  margin-top: 9px;
  margin-bottom: 9px;
  margin-left: 0.5%;
  margin-right: 0.5%;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
}

.tituloColor {
  color: #0080c8;
  font-weight: 700;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  text-decoration: underline;
}

.bg-verde {
  background-color: rgb(19, 163, 38);
}

.bg-solimano {
  border-color: #0080c8;
  border-width: 2px;
}

.tamaño {
  font-size: 0.65rem;
  color: #002c5d;
  font-weight: 500;
}

.tamaños {
  font-size: 0.65rem;

  font-weight: 500;
}


.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}
</style>
